import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../Auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(public authService: AuthService, public router: Router) { }

  async canActivate() {
    if (this.authService.getToken()) {
      return true;
    }
    await this.router.navigate(['login']);
    return false;
  }
}